import {
  Component,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Subject } from "rxjs";
import { CommonApiService } from "./../shared/services/api/common-api.service";
import { ViewStateService } from "./../shared/services/view-state.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-licensure-list",
  templateUrl: "./licensure-list.component.html",
})
export class LicensureListComponent implements OnInit, OnDestroy {
  licensureList: any[];
  private destroy$ = new Subject<void>();

  constructor(    
    private viewState: ViewStateService,
    private commonApiService: CommonApiService
  ) { }

  ngOnInit() {
    this.viewState.startLoading();
    this.getStateLicensures();
  }

  private getStateLicensures() {
    this.commonApiService
      .getStateLicensures()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.licensureList = res;
        this.viewState.stopLoading();
      });
  }

  formatPhone(phone: string): string {
    if (phone.length === 10) {
      return `${phone.slice(0, 3)}.${phone.slice(3, 6)}.${phone.slice(6)}`;
    }

    if (phone.length === 11) {
      return `1.${phone.slice(1, 4)}.${phone.slice(4, 7)}.${phone.slice(7)}`;
    }

    return phone;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
